/* eslint-disable max-len */
import {NgModule} from "@angular/core";
import {I18nService} from "./i18n/i18n.service";
import {LanguageProvider} from "./i18n/language-provider";
import {UserLanguageProvider} from "./i18n/user-language-provider";
import {BpFindingsValidator} from "./features/analize/blood-pressure/bp-findings-validator";
import {EcgFindingsValidator} from "./features/analize/ecg/ecg-findings-validator";
import {LoginValidator} from "./features/login/login-validator";
import {UploadFileValidator} from "./features/upload/upload-file/upload-file-validator";
import {DateTimeSerializationService} from "./tools/formatting/date-time-serialization.service";
import {ChartService} from "./features/analize/blood-pressure/blood-pressure-chart/chart.service";
import {SupportedLanguagesProvider} from "./tools/supported-languages-provider";
import {BloodPressureReportGenerator} from "./features/analize/bp-report/blood-pressure-report-generator.service";
import {ConvertPdfBase64ToResourceUrlService} from "./features/analize/ecg/convert-pdf-base64-to-resource-url.service";
import {DoctorSelectorService} from "./features/list/doctor-selector/doctor-selector.service";
import {ReportFilenameFactory} from "./features/list/report/download/report-filename-factory.service";
import {ListItemTextBuilder} from "./features/list/list-item-text-builder.service";
import {SleepReportGenerator} from "./features/analize/sleep-report/sleep-report-generator.service";
import {EcgReportGenerator} from "./features/analize/ecg-report/ecg-report-generator.service";
import {MeasurementDetailsService} from "./features/list/measurement-details/measurement-details.service";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {AgGridModule} from "ag-grid-angular";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {ModalModule} from "ngx-bootstrap/modal";
import {PaginationModule} from "ngx-bootstrap/pagination";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import {TypeaheadModule} from "ngx-bootstrap/typeahead";
import {RecaptchaModule} from "ng-recaptcha";
import {AutosizeModule} from "ngx-autosize";
import {BasicPatientDataDisplayComponent} from "./features/analize/basic-patient-data-display/basic-patient-data-display.component";
import {BloodPressureTableComponent} from "./features/analize/blood-pressure/blood-pressure-table/blood-pressure-table.component";
import {ListComponent} from "./features/list/list.component";
import {UploadComponent} from "./features/upload/upload.component";
import {NotificationsComponent} from "./tools/notifications/notifications.component";
import {LocalizePipe} from "./i18n/localize-pipe";
import {FormFieldWrapperComponent} from "./tools/form/form-field-wrapper.component";
import {FormFieldComponent} from "./tools/form/form-field.component";
import {FormHeaderComponent} from "./tools/form/form-header.component";
import {ActionButtonComponent} from "./tools/button/action-button.component";
import {LoadingIndicatorComponent} from "./tools/loading-indicator/loading-indicator.component";
import {DoctorSelectorComponent} from "./features/list/doctor-selector/doctor-selector.component";
import {LoginComponent} from "./features/login/login.component";
import {OtpComponent} from "./features/login/otp/otp.component";
import {UserCredentialsComponent} from "./features/login/user-credentials/user-credentials.component";
import {ReportUploadComponent} from "./features/list/report/report-upload.component";
import {FooterComponent} from "./footer.component";
import {SleepUploadFormComponent} from "./features/upload/sleep/sleep-upload-form.component";
import {HolterEcgUploadFormComponent} from "./features/upload/holter-ecg/holter-ecg-upload-form.component";
import {SymptomHolterUploadFormComponent} from "./features/upload/symptom-holter/symptom-holter-upload-form.component";
import {EcgAtrialFibrillationUploadFormComponent,} from "./features/upload/ecg-atrial-fibrillation/ecg-atrial-fibrillation-upload-form.component";
import {BloodPressureUploadFormComponent} from "./features/upload/blood-pressure/blood-pressure-upload-form.component";
import {UploadMeasurementFileComponent} from "./features/upload/upload-file/upload-measurement-file.component";
import {EcgSymptomComponent} from "./features/upload/symptom-holter/ecg-symptom.component";
import {DateTimePickerComponent} from "./tools/date-time-picker/date-time-picker.component";
import {EcgAnalysisComponent} from "./features/analize/ecg/ecg-analysis.component";
import {FormFieldDisplayComponent} from "./tools/form/form-field-display.component";
import {AppLocalDateTimePipe} from "./tools/date-time.pipe";
import {ReturnStudyComponent} from "./features/list/return-study/return-study.component";
import {MeasurementDetailsButtonComponent} from "./features/list/measurement-details/measurement-details-button.component";
import {MeasurementDetailsComponent} from "./features/list/measurement-details/measurement-details.component";
import {ErrorComponent} from "./tools/errors/error.component";
import {ActionLogComponent} from "./features/action-log/action-log.component";
import {MapCellRendererComponent} from "./tools/ag-grid-custom-components/map-cell-renderer/map-cell-renderer.component";
import {DateWithCopyRendererComponent} from "./tools/ag-grid-custom-components/date-with-copy-renderer/date-with-copy-renderer.component";
import {BpAnalysisComponent} from "./features/analize/blood-pressure/bp-analysis.component";
import {SleepAnalysisComponent} from "./features/analize/sleep/sleep-analysis.component";
import {SleepMeasurementsComponent} from "./features/analize/sleep/sleep-measurements/sleep-measurements.component";
import {AddNursesComponent} from "./features/add-nurses/add-nurses.component";
import {UserMenuComponent} from "./features/user-menu/user-menu.component";
import {ChangePasswordComponent} from "./features/change-password/change-password.component";
import {ChangeLanguageComponent} from "./features/change-language/change-language.component";
import {UserListComponent} from "./features/user-list/user-list.component";
import {BackgroundInformationComponent} from "./features/background-information/background-information.component";
import {BloodPressureChartComponent} from "./features/analize/blood-pressure/blood-pressure-chart/blood-pressure-chart.component";
import {BloodPressureFindingsComponent} from "./features/analize/blood-pressure/blood-pressure-findings/blood-pressure-findings.component";
import {TimeFilterComponent} from "./features/user-list/time-filter/time-filter.component";
import {SelectComponent} from "./tools/select/select.component";
import {InitiateMeasurementComponent} from "./features/initiate-measurement/initiate-measurement.component";
import {PrintOrderFormComponent} from "./features/print-order-form/print-order-form.component";
import {HospitalsComponent} from "./features/hospitals/hospitals.component";
import {EditHospitalComponent} from "./features/hospitals/edit-hospital/edit-hospital.component";
import {PrintFormComponent} from "./features/print-form/print-form.component";
import {EFormLandingPageComponent} from "./features/e-forms/landing-page/e-form-landing-page.component";
import {EFormFormComponent} from "./features/e-forms/form/e-form-form.component";
import {CommentsComponent} from "./features/comments/comments.component";
import {EditMeasurementComponent} from "./features/list/edit-measurement/edit-measurement/edit-measurement.component";
import {UploadFormSelectorComponent} from "./features/upload/form-selector/upload-form-selector.component";
import {CharacterCounterComponent} from "./tools/form/character-counter/character-counter/character-counter.component";
import {PatientStatusCommentsGeneratorComponent} from "./features/analize/ecg/generators/patient-status-comments-generator/patient-status-comments-generator.component";
import {SelectionGeneratorComponent} from "./features/analize/ecg/generators/widgets/selection-generator/selection-generator.component";
import {ValueGeneratorComponent} from "./features/analize/ecg/generators/widgets/value-generator/value-generator.component";
import {FindingsGeneratorComponent} from "./features/analize/ecg/generators/findings-generator/findings-generator.component";
import {DiagnosisGeneratorComponent} from "./features/analize/ecg/generators/diagnosis-generator/diagnosis-generator.component";
import {GeneratorTextFieldComponent} from "./features/analize/ecg/generators/widgets/generator-text-field/generator-text-field.component";
import {ListItemComponent} from "./features/list/list-item/list-item.component";
import {HolterTypeEditorComponent} from "./features/list/edit-holter-type/holter-type-editor.component";
import {ListItemActionButtonsComponent} from "./features/list/list-item/list-item-action-buttons/list-item-action-buttons.component";
import {ReassignDoctorButtonComponent} from "./features/list/reassign-doctor/reassign-doctor-button/reassign-doctor-button.component";
import {ChainSectionComponent} from "./features/hospitals/edit-hospital/chain-section/chain-section.component";
import {NurseSettingsSectionComponent} from "./features/hospitals/edit-hospital/nurse-settings-section/nurse-settings-section.component";
import {ReportLanguageSectionComponent} from "./features/hospitals/edit-hospital/report-language-section/report-language-section.component";
import {DownloadReportComponent} from "./features/list/list-item/download-report/download-report.component";
import {AllowedTypesSectionComponent} from "./features/hospitals/edit-hospital/allowed-types-section/allowed-types-section.component";
import {EFormHeaderComponent} from "./features/e-forms/form/header/e-form-header.component";
import {EFormMailingInfoComponent} from "./features/e-forms/form/mailing-info/e-form-mailing-info.component";
import {NavigationComponent} from "./features/header/navigation.component";
import {MailDeviceComponent} from "./features/mail-device/mail-device.component";
import {EFormPatientDataComponent} from "./features/e-forms/form/patient-data/e-form-patient-data.component";
import {FinishMeasuringComponent} from "./features/e-forms/form/finish-measuring/finish-measuring.component";
import {UploadInitiatedButtonComponent} from "./features/list/list-item/upload-initiated-button/upload-initiated-button.component";
import {EformFooterComponent} from "./features/e-forms/form/eform-footer/eform-footer.component";
import {MailingInfoComponent} from "./features/list/list-item/mailing-info/mailing-info.component";
import {PreConfirmActionButtonComponent} from "./tools/confirm-action-button/pre-confirm-action-button.component";
import {NavigateToPrintFormComponent} from "./features/list/print-form/navigate-to-print-form.component";
import {NavigateToPrintOrderComponent} from "./features/list/order-form/navigate-to-print-order.component";
import {ForgotPasswordComponent} from "./features/login/forgot-password/forgot-password.component";
import {CommentsButtonComponent} from "./features/list/list-item/comments-button/comments-button.component";
import {ChainsComponent} from "./features/chains/chains.component";
import {ChainDetailsComponent} from "./features/chains/chain-details/chain-details.component";
import {TechniciansSectionComponent} from "./features/hospitals/edit-hospital/technicians-section/technicians-section.component";
import {UploadButtonComponent} from "./features/upload/upload-button/upload-button.component";
import {EcgPreanalysisDataComponent} from "./features/analize/ecg/ecg-preanalysis-data/ecg-preanalysis-data.component";
import {EcgSymptomDescriptionsComponent} from "./features/analize/ecg/ecg-symptom-descriptions/ecg-symptom-descriptions.component";
import {GeneratorSentencesComponent} from "./features/analize/ecg/generators/generator-sentences/generator-sentences.component";
import {FieldInfoComponent} from "./features/analize/ecg/generators/widgets/selection-generator/field-info/field-info.component";
import {ReassignTechnicianComponent} from "./features/list/list-item/list-item-action-buttons/reassign-technician/reassign-technician.component";
import {TranslationsComponent} from "./features/translations/translations.component";
import {ReleaseFeaturesComponent} from "./features/release-features/release-features.component";

const components = [
  BasicPatientDataDisplayComponent,
  BloodPressureTableComponent,
  ListComponent,
  UploadComponent,
  NotificationsComponent,
  LocalizePipe,
  FormFieldWrapperComponent,
  FormFieldComponent,
  FormHeaderComponent,
  ActionButtonComponent,
  LoadingIndicatorComponent,
  DoctorSelectorComponent,
  LoginComponent,
  OtpComponent,
  UserCredentialsComponent,
  ReportUploadComponent,
  FooterComponent,
  SleepUploadFormComponent,
  HolterEcgUploadFormComponent,
  SymptomHolterUploadFormComponent,
  EcgAtrialFibrillationUploadFormComponent,
  BloodPressureUploadFormComponent,
  UploadMeasurementFileComponent,
  EcgSymptomComponent,
  DateTimePickerComponent,
  EcgAnalysisComponent,
  FormFieldDisplayComponent,
  AppLocalDateTimePipe,
  ReturnStudyComponent,
  MeasurementDetailsButtonComponent,
  MeasurementDetailsComponent,
  ErrorComponent,
  ActionLogComponent,
  MapCellRendererComponent,
  DateWithCopyRendererComponent,
  BpAnalysisComponent,
  SleepAnalysisComponent,
  SleepMeasurementsComponent,
  AddNursesComponent,
  UserMenuComponent,
  ChangePasswordComponent,
  ChangeLanguageComponent,
  UserListComponent,
  BackgroundInformationComponent,
  BloodPressureChartComponent,
  BloodPressureFindingsComponent,
  TimeFilterComponent,
  SelectComponent,
  InitiateMeasurementComponent,
  PrintOrderFormComponent,
  HospitalsComponent,
  EditHospitalComponent,
  PrintFormComponent,
  EFormLandingPageComponent,
  EFormFormComponent,
  CommentsComponent,
  EditMeasurementComponent,
  UploadFormSelectorComponent,
  CharacterCounterComponent,
  PatientStatusCommentsGeneratorComponent,
  SelectionGeneratorComponent,
  ValueGeneratorComponent,
  FindingsGeneratorComponent,
  DiagnosisGeneratorComponent,
  GeneratorTextFieldComponent,
  ListItemComponent,
  HolterTypeEditorComponent,
  ListItemActionButtonsComponent,
  ReassignDoctorButtonComponent,
  ChainSectionComponent,
  NurseSettingsSectionComponent,
  ReportLanguageSectionComponent,
  DownloadReportComponent,
  AllowedTypesSectionComponent,
  EFormHeaderComponent,
  EFormMailingInfoComponent,
  NavigationComponent,
  MailDeviceComponent,
  EFormPatientDataComponent,
  FinishMeasuringComponent,
  UploadInitiatedButtonComponent,
  EformFooterComponent,
  MailingInfoComponent,
  PreConfirmActionButtonComponent,
  NavigateToPrintFormComponent,
  NavigateToPrintOrderComponent,
  ForgotPasswordComponent,
  CommentsButtonComponent,
  ChainsComponent,
  ChainDetailsComponent,
  TechniciansSectionComponent,
  UploadButtonComponent,
  EcgPreanalysisDataComponent,
  EcgSymptomDescriptionsComponent,
  GeneratorSentencesComponent,
  FieldInfoComponent,
  ReassignTechnicianComponent,
  TranslationsComponent,
  ReleaseFeaturesComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AgGridModule,
    AutosizeModule,
    RecaptchaModule,
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    TimepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  providers: [
    I18nService,
    {
      provide: LanguageProvider,
      useClass: UserLanguageProvider
    },
    DoctorSelectorService,
    ReportFilenameFactory,
    ListItemTextBuilder,
    SleepReportGenerator,
    MeasurementDetailsService,
    BpFindingsValidator,
    EcgFindingsValidator,
    LoginValidator,
    UploadFileValidator,
    DateTimeSerializationService,
    ChartService,
    SupportedLanguagesProvider,
    BloodPressureReportGenerator,
    ConvertPdfBase64ToResourceUrlService,
    EcgReportGenerator,
  ],
  exports: components,
})
export class AppModule {
}
